const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

const isDebugMode = () => {
  if (!isProduction) return true;
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('debug') === 'true' || localStorage.getItem('debug') === 'true';
  } catch (error) {
    // Cannot access window or localStorage, default to no-debug
    return false;
  }
};

/**
 * A simple logger that only logs in development or when a debug flag is set.
 * This helps keep the production console clean and secure.
 */
export const logger = {
  log: (...args: unknown[]) => {
    if (isDebugMode()) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDebugMode()) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    // Errors should always be logged
    console.error(...args);
  },
  info: (...args: unknown[]) => {
    if (isDebugMode()) {
      console.info(...args);
    }
  },
};
